
export function average(values) {
    const sum = values.reduce(add, 0);
    return sum / values.length;
}

function add(a, b) {
    return a + b;
}

export function image(path) {
    if (window.location.hostname.includes('p203')) {
        return 'https://' + window.location.hostname  + '/assets/images/' + path;
    }
    return 'https://a.spqcdn.net/rabattkoder-dagbladet/images/' + path;
}

/**
 * Listens on all clicks and hides element with given selector if click is outside of it.
 *
 * TODO prettier hide/show. Use hide-class instead.
 *
 * @param selector
 */
export function hideOnClickOutside(selector) {

    const outsideClickListener = (event) => {
        let $target = $(event.target);
        if (!$target.closest(selector).length && $(selector).is(':visible')) {
            $(selector).hide();
            removeClickListener();
        }
    }

    const removeClickListener = () => {
        document.removeEventListener('click', outsideClickListener)
    }

    document.addEventListener('click', outsideClickListener)
}